
































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import MultiLevelObject from "@/interfaces/MultiLevelObject";
import MultiLevelDropdown from "./MultiLevelDropdown.vue";

const DEFAULT_PLACEHOLDER = "Selezionare una voce";

export interface MultiLevelMultipleObject {
  [key: number]: MultiLevelObject[];
}

@Component({
  components: {
    MultiLevelDropdown,
  },
})
export default class MultiLevelSelect extends Vue {
  @Prop() readonly value!: string | Array<string[]> | null;
  @Prop({ default: DEFAULT_PLACEHOLDER }) readonly placeholder?: string;
  @Prop({
    default: () => {
      return [];
    },
  })
  readonly headers?: Array<string>;
  @Prop({
    default: () => {
      return [];
    },
  })
  readonly options!: Array<MultiLevelObject>;
  @Prop({ default: false }) readonly multiple?: boolean;
  @Prop({ default: 0 }) readonly level!: number;
  @Prop({ default: false }) readonly small!: boolean;
  @Prop({ default: false }) readonly hasAlignRight!: boolean;

  @Watch("value")
  onValueChange(value: string | Array<string[]> | null) {
    this.updateSelected(value);
  }

  @Watch("options", { deep: true })
  onOptionsChanged(value: Array<MultiLevelObject>) {
    this.items = [...value];
  }

  created() {
    this.items = [...this.options];
  }

  mounted() {
    this.updateSelected(this.value);
  }

  visible = false;
  items: MultiLevelObject[] = [];
  selected: MultiLevelObject | null = null;
  selectedLevel = this.level;
  selectedMultiple: MultiLevelMultipleObject = {};

  get label(): string {
    if (this.multiple) {
      let first: MultiLevelObject | null = null;
      let count = 0;

      for (const level in this.selectedMultiple) {
        if (
          first == null &&
          this.selectedMultiple[level] &&
          this.selectedMultiple[level].length
        ) {
          first = this.selectedMultiple[level][0];
        }

        count += this.selectedMultiple[level].length;
      }

      if (count && first) {
        let label = first.text;

        if (count > 1) {
          label += ` + altre ${count - 1}`;
        }

        return label;
      } else {
        return this.placeholder || DEFAULT_PLACEHOLDER;
      }
    } else {
      if (this.selected == null) {
        return this.placeholder || DEFAULT_PLACEHOLDER;
      }

      return this.selected.text;
    }
  }

  toggleDropdown() {
    this.visible = !this.visible;
  }

  closeDropdown() {
    if (this.visible) {
      this.visible = false;
    }
  }

  updateSelected(value: string | Array<string[]> | null) {
    if (this.multiple && Array.isArray(value)) {
      this.selectedMultiple = {};

      for (let i = 0; i < (value as Array<string[]>).length; i++) {
        this.selectedMultiple[i] = [];
      }

      this.updateSelectedMultiple(this.options, 0);
    } else {
      if (value && this.items) {
        const option = this.items.find((e) => e.id == value);
        if (option && this.selectedLevel === 0) {
          this.selected = option;
        } else {
          this.items.forEach((parent) => {
            const option = parent.children?.find((e) => e.id == value);
            if (option && this.selectedLevel === 1) {
              this.selected = option;
            } else {
              parent.children?.forEach((parent) => {
                const option = parent.children?.find((e) => e.id == value);
                if (option && this.selectedLevel === 2) {
                  this.selected = option;
                }
              });
            }
          });
        }
      }
    }
  }

  updateSelectedMultiple(
    options: MultiLevelObject[],
    level: number,
    parent: MultiLevelObject | null = null
  ) {
    options.map((option) => {
      if (this.value && this.value[level]) {
        option.selected = this.value[level].indexOf(option.id) >= 0;

        if (option.selected) {
          this.selectedMultiple[level].push(option);

          if (parent && parent.selected == false) {
            this.$set(parent, "partial", true);
          }
        } else if (parent && parent.selected) {
          option.selected = true;
        }

        if (option.children && option.children.length) {
          this.updateSelectedMultiple(option.children, level + 1, option);
        }

        return option;
      }
    });
  }

  processMultipleOptions(options: MultiLevelObject[], level = 0) {
    if (!this.selectedMultiple[level]) {
      this.selectedMultiple[level] = [];
    }

    options.forEach((option) => {
      if (option.selected) {
        this.selectedMultiple[level].push(option);
      }

      if (option.partial && option.children) {
        this.processMultipleOptions(option.children, level + 1);
      }
    });
  }

  emitMultipleValue() {
    const length = (this.value as Array<string[]>).length;
    const empty: string[] = [];
    const value = Array(length).map(() => empty);

    for (let i = 0; i < length; i++) {
      if (this.selectedMultiple[i] == undefined) {
        value[i] = [];
      } else {
        value[i] = this.selectedMultiple[i].map((element) => {
          return element.id;
        });
      }
    }

    this.$emit("input", value);
  }

  onSelected(option: MultiLevelObject, level: number) {
    if (this.multiple) {
      if (this.items) {
        this.selectedMultiple = {};
        this.processMultipleOptions(this.items, 0);
        this.emitMultipleValue();
      }
    } else {
      this.closeDropdown();
      this.selected = option;
      this.$emit("input", option.id);
    }
    this.selectedLevel = level;
    this.$emit("selected", option, level);
  }
}
